export const getErrorMessageFromApiError = (e: any) =>
  e?.body?.message || e?.response?.data?.message; // CT // WebApp
